import Radio from 'backbone.radio';
import DUTDeviceGroupSettingsDialog from '@/views/dialogs/dut_device_group_settings';


    var globalCh = Radio.channel('global');

    // factory_group is an optional argument that allows the setting dialog to be launched
    // with a pre_production_devicegroup, but still know what group it's the production_target
    // of
    export default function show_product_settings_dialog(devicegroup){
        var view = new DUTDeviceGroupSettingsDialog({
            model: devicegroup,
        });

        globalCh.request('showDialog', view);
    }

